import { P2GText } from '@parcel2go/core-ui';
import { Dimensions } from '~/lib/api/smartsend/types';
import { useMeasurementSystem } from '~/hooks/use-measurement-system';
import {
  LocalUnitsEntry,
  formatWeightString,
  formatDimensionsString
} from '~/apps/smartsend/lib/helpers/DimensionUnits';

interface props {
  dimensions: Dimensions;
  localUnitsEntry?: LocalUnitsEntry;
  variant?: 'h4' | 'h5' | 'h6' | 'subtitle1' | 'subtitle2' | 'body1' | 'body2' | 'button';
  colour?: 'initial' | 'inherit' | 'primary' | 'secondary' | 'textPrimary' | 'textSecondary' | 'error';
}

export function DimensionAndWeightDisplay(props: props) {
  const { unit } = useMeasurementSystem();
  if (
    !props.dimensions ||
    (!props.dimensions.Height && !props.dimensions.Width && !props.dimensions.Length && !props.dimensions.Weight)
  ) {
    return null;
  }

  return (
    <P2GText variant={props.variant} colour={props.colour}>
      {props.dimensions.Weight > 0 && (
        <>{formatWeightString(props.dimensions.Weight, unit, { localUnitsEntry: props.localUnitsEntry })}</>
      )}
      {props.dimensions.Length > 0 && props.dimensions.Width > 0 && props.dimensions.Height > 0 && (
        <>
          {props.dimensions.Weight > 0 && <>&nbsp;&nbsp;|&nbsp;&nbsp;</>}
          <P2GText variant={props.variant} small>
            {formatDimensionsString(
              { length: props.dimensions.Length, width: props.dimensions.Width, height: props.dimensions.Height },
              unit,
              { localUnitsEntry: props.localUnitsEntry }
            )}
          </P2GText>
        </>
      )}
    </P2GText>
  );
}

export function DimensionDisplay(props: Dimensions) {
  if (props.Length && props.Width && props.Height) {
    return `${props.Length} x ${props.Width} x ${props.Height}`;
  }
  return null;
}
